export default __webpack_public_path__ + "static/media/logomake.417fbeba.png";